<template>
    <v-btn 
       v-if="showWhatsApp"
        color="#25D366"
        fab
        large
        dark
        style="position:fixed;right:10px;bottom:90px;"
        @click="handleSendWhatsApp"
      >
        <v-icon>mdi-whatsapp</v-icon>
      </v-btn>
</template>
<script>
  import utils from '@/services/utils'
  import api from '@/services/api'
  export default {
    data () {
      return {
        whatsApp: false,
	      whatsAppAuth: true,
	      whatsAppPhone: '',
	      showWhatsApp: false,
      }
    },
    watch: {
      '$store.state.app.authData' () {
        this.prepareWhatsApp()
      }
    },
    mounted () {
      const enterpriseIDDomain = this.$store.state.app.enterpriseID ? this.$store.state.app.enterpriseID : utils.getDomain()
      api.getItem('utils', false, `whatsapp/${enterpriseIDDomain}`).then(response => {
	      this.whatsAppPhone = response.WhatsAppPhone
	      this.whatsApp = response.WhatsApp === 1
        this.whatsAppAuth = response.WhatsAppAuth === 1
        this.prepareWhatsApp()
      })
    },
    methods: {
      prepareWhatsApp () {
        if (this.whatsApp && this.whatsAppPhone.length > 0) {
          if (!this.whatsAppAuth || this.$store.state.app.authData) this.showWhatsApp = true
          else this.showWhatsApp = false
        } else this.showWhatsApp = false
      },
      handleSendWhatsApp () {
        //const url = `https://wa.me/${this.whatsAppPhone}?text=I'm%20interested%20in%20your%20car%20for%20sale`
        const url = `https://wa.me/${this.whatsAppPhone}?text=`
        window.location.href = url
      },
    }
  }
</script>
